import Vue from 'vue';
import '@/assets/stylesheets/v2/_step-indicator.scss';
import { Step } from '@/helpers/entities/enums/v2/Step';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
export default Vue.extend({
    mixins: [ViewportSizeMixin],
    props: {
        step: {
            type: Number,
            required: true,
        },
        isAffiliate: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        steps() {
            if (this.isAffiliate) {
                return [
                    {
                        name: 'Connect Facebook Page',
                        step: Step.One,
                    },
                    {
                        name: 'Product Marketplace',
                        step: Step.Two,
                    },
                    {
                        name: 'Affiliate Commission Disbursement',
                        step: Step.Three,
                    },
                ];
            }
            return [
                {
                    name: 'Choose Service Bundle',
                    step: Step.One,
                },
                // {
                //   name: 'Choose your plan',
                //   step: Step.Two,
                // },
                {
                    name: 'Connect Facebook Page',
                    step: Step.Two,
                },
                {
                    name: 'Setup In-App Store',
                    step: Step.Three,
                },
            ];
        },
        stepStyles() {
            return ['shrink', 'mr-2', 'step'];
        },
        nameStyles() {
            const self = this;
            const defaultClasses = ['name'];
            if (self.xsOnly) {
                return [...defaultClasses, '-mobile'];
            }
            return defaultClasses;
        },
    },
    methods: {
        isActive(step) {
            return this.step === step;
        },
        isCompleted(step) {
            return step < this.step;
        },
        isDisabled(step) {
            return step > this.step;
        },
        indicatorStylesFor(step) {
            const styles = ['align-center', 'indicator', 'px-1'];
            if (this.isActive(step)) {
                return styles.concat('-active').join(' ');
            }
            return styles.join(' ');
        },
        stylesFor(step, styles) {
            if (this.isCompleted(step)) {
                return styles.concat('-completed').join(' ');
            }
            if (this.isDisabled(step)) {
                return styles.concat('-disabled').join(' ');
            }
            return styles.join(' ');
        },
    },
    render(createElement) {
        const self = this;
        return createElement('v-layout', { class: { 'step-indicator': self.smAndUp, 'step-indicator -mobile': self.xsOnly } }, this.steps.map((step) => {
            return createElement('v-flex', [
                createElement('v-layout', {
                    class: this.indicatorStylesFor(step.step),
                    attrs: {
                        id: `step-${step.step}`,
                    },
                }, [
                    createElement('v-flex', {
                        class: this.stylesFor(step.step, this.stepStyles),
                    }, step.step.toString()),
                    createElement('v-flex', {
                        class: this.stylesFor(step.step, this.nameStyles),
                    }, step.name),
                ]),
                createElement('v-layout', [createElement('v-flex', { class: 'progress' })]),
            ]);
        }));
    },
});
